export const availableTags = [ "div", "ul", "ol", "article" ] as const;

export const gridGapsMap = {
  default: "gap-4",
  xl: "gap-8 lg:gap-12",
  lg: "gap-6 lg:gap-8",
  md: "gap-3",
  sm: "gap-2",
  xs: "gap-1",
  none: "gap-0",
};

export const gridMaxColumnsMap = {
  default: "grid-cols-12",
  three: "grid-cols-2 lg:grid-cols-3",
  four: "grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
  six: "grid-cols-2 md:grid-cols-3 lg:grid-cols-6",
};

export type AvailableTag = typeof availableTags[number];
export type Gap = keyof typeof gridGapsMap;
export type MaxColumns = keyof typeof gridMaxColumnsMap;
